<div ngModelGroup="comboTipoEscola-{{data}}" fxFlex="100" fxLayoutGap="20px">
    <combo-pesquisavel #comboTipoEscola
                       nome="tipoEscola-{{data}}"
                       [itens]="dados"
                       itemDescricao="tipo"
                       itemId="flag"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Tipo da Escola"
                       label="Tipo da Escola"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>
